const Theme = localStorage.getItem('Theme');

export default [
  {
    path: '/transaction',
    component: () => import(/* webpackChunkName: "Transaction" */`@/modules/FPKG-10000-Theme/layout/${Theme === null ? 'DEFAULT' : Theme}/index.vue`),
    children: [
      // 申請
      {
        path: 'apply/lists',
        name: 'apply-lists',
        component: () => import(/* webpackChunkName: "Transaction" */'@/modules/FPKG-70000-Transaction/apply/lists.vue'),
        meta: {
          title: 'NODE_8',
          url: 'transaction/apply/lists',
          toolbar: ['search', 'advSearch', 'pager', 'create'],
        },
      },
      {
        path: 'apply/create',
        name: 'apply-create',
        component: () => import(/* webpackChunkName: "Transaction" */'@/modules/FPKG-70000-Transaction/apply/create.vue'),
        meta: {
          title: 'NODE_8',
          url: 'transaction/apply/lists',
          toolbar: ['keepCreate', 'saveAndGo'],

        },
      },

      // 回復
      {
        path: 'reply/lists',
        name: 'reply-lists',
        component: () => import(/* webpackChunkName: "Transaction" */'@/modules/FPKG-70000-Transaction/reply/lists.vue'),
        meta: {
          title: 'NODE_9',
          url: 'transaction/reply/lists',
          toolbar: ['search', 'advSearch', 'pager'],
        },
      },
      // 紀錄
      {
        path: 'record/lists',
        name: 'record-lists',
        component: () => import(/* webpackChunkName: "Transaction" */'@/modules/FPKG-70000-Transaction/record/lists.vue'),
        meta: {
          title: 'NODE_10',
          url: 'transaction/record/lists',
          toolbar: ['search', 'advSearch', 'pager', 'delete'],
        },
      },
      // 門市盈虧
      {
        path: 'department/info',
        name: 'transaction-department-info',
        component: () => import(/* webpackChunkName: "Transaction" */'@/modules/FPKG-70000-Transaction/department/info.vue'),
        meta: {
          title: 'NODE_11',
          url: 'transaction/department/info',
          toolbar: ['yesterday', 'today', 'BeforeWeek', 'Week', 'BeforeMoon', 'Moon', 'customTime'],
        },
      },
      // 盈虧
      {
        path: 'total/info',
        name: 'transaction-total-info',
        component: () => import(/* webpackChunkName: "Transaction" */'@/modules/FPKG-70000-Transaction/total/info.vue'),
        meta: {
          title: 'NODE_12',
          url: 'transaction/total/info',
          toolbar: ['yesterday', 'today', 'BeforeWeek', 'Week', 'BeforeMoon', 'Moon', 'customTime'],
        },
      },
    ],
  },
];
